<mat-form-field style="width: 100%">
    <mat-label>{{ placeholder }}</mat-label>
    <mat-hint>{{ hintMessage }}</mat-hint>
    <input
        #articleInput="matInput"
        (blur)="onBlur($event)"
        [formControl]="materialFormCtrl"
        [matAutocomplete]="autoMaterial"
        [placeholder]="placeholder"
        [required]="required"
        matInput
        [attr.data-cy]="'casaasa_input_1_1_'"
    />
    <button
        (click)="clearAndFocus()"
        *ngIf="showClearButton"
        [disabled]="disabled"
        mat-icon-button
        matSuffix
        type="button"
        [attr.data-cy]="'casaasa_button_1_0_'"
    >
        <mat-icon [attr.data-cy]="'casaasa_mat-icon_1_2_'">clear</mat-icon>
    </button>
    <mat-autocomplete
        #autoMaterial="matAutocomplete"
        (optionActivated)="optionActivated($event)"
        (optionSelected)="autocompleteMaterialSelected($event)"
        [displayWith]="materialMapper"
        [panelWidth]="'700px'"
    >
        <mat-option
            *ngFor="let m of materialien | async; let i = index"
            [value]="m"
            [attr.data-cy]="'taapdaapd_mat-option_' + i"
        >
            <span
                >{{ m.artikel_me }}
                <span *ngIf="kuerzel && m.kuerzel"> ({{ m.kuerzel }})</span>
                <span *ngIf="m.artikelnr_lieferant"> [{{ m.artikelnr_lieferant }}]</span>
                <span *ngIf="lieferantAnzeigen && m.lieferant_labor">- Lieferant: {{ m.lieferant_labor }}</span>
            </span>
            <span *ngIf="showPrice"> - {{ (m.einzelpreis ? m.einzelpreis : 0) | number: "1.2-2" }} &euro; </span>
        </mat-option>
    </mat-autocomplete>
</mat-form-field>
